import React from "react";
import PropTypes from "prop-types";
import { Icon } from "antd";

const BAND_ICON = {
    pass: "check-circle",
    warn: "exclamation-circle",
    fail: "close-circle",
    info: "info-circle"
};

/**
 * The three checks an ARP analyst runs: Ledger Sales, Ledger Repayment, ARP.
 * Each shows the metric value, a band pill and the gating note.
 */
const TriangulationChecks = ({ checks }) => (
    <div className={"cc-checks"}>
        {checks.map(check => (
            <div className={"cc-check cc-check--" + check.band} key={check.key}>
                <div className={"cc-check__top"}>
                    <Icon
                        type={BAND_ICON[check.band] || "info-circle"}
                        theme={"filled"}
                        className={"cc-check__icon"}
                    />
                    <div className={"cc-check__titles"}>
                        <span className={"cc-check__label"}>{check.label}</span>
                        <span className={"cc-check__sub"}>{check.sub}</span>
                    </div>
                    <span className={"cc-check__value"}>{check.value}</span>
                </div>
                <div className={"cc-check__note"}>{check.note}</div>
            </div>
        ))}
    </div>
);

TriangulationChecks.propTypes = {
    checks: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string,
            label: PropTypes.string,
            sub: PropTypes.string,
            value: PropTypes.node,
            band: PropTypes.string,
            note: PropTypes.string
        })
    ).isRequired
};

export default TriangulationChecks;
